import { GET_BOOKING_REQUESTED } from "resources/actionTypes"

export function getBooking(data) {
  return {
    type: GET_BOOKING_REQUESTED,
    payload: data
  };
}
